export function handleEnableDisableScrollMobile(type = 'enable', isPreventScroll = false) {
  if (typeof document === 'undefined') return;

  if (type === 'disable') {
    document.body.style.overflow = 'hidden';
    document.getElementById('__next').style.overflow = 'hidden';
    document.getElementById('__next').style.height = '100dvh';
  } else if (type === 'enable') {
    if (!isPreventScroll) {
      document.body.style.overflow = 'unset';
      document.getElementById('__next').style.overflow = 'unset';
    }
    document.getElementById('__next').style.height = 'auto';
  }
}

export default handleEnableDisableScrollMobile;
